import { Clock, Coffee, Rocket, MapPin } from 'lucide-react';
import { valueProps } from '../../mock';

const iconMap = { Clock, Coffee, Rocket, MapPin };

export default function ValueProps() {
  return (
    <section className="py-16 md:py-20 bg-[#f6f3ea]">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {valueProps.map((v, i) => {
            const Icon = iconMap[v.icon] || Clock;
            return (
              <div
                key={v.title}
                className={`bg-white rounded-2xl p-6 border border-stone-200 hover:border-[#0b6b5b]/40 transition-colors fade-up delay-${(i % 4) + 1}`}
              >
                <div className="h-12 w-12 rounded-xl bg-[#0b6b5b]/10 grid place-items-center mb-4">
                  <Icon className="h-6 w-6 text-[#0b6b5b]" />
                </div>
                <h3 className="font-display font-semibold text-lg text-stone-900">
                  {v.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-stone-600">{v.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
